// Logo de Divflow sin fondo (icons/Group 2.svg), dibujado con el color del texto para que se vea en los dos temas.
// Va en la cabecera (panel de proyectos y barra superior) y en la pantalla de entrada. Es decorativo: al lado siempre
// hay un texto que dice dónde se está.
export function LogoMark({ height, className }: { height: number; className?: string }) {
  return (
    <svg
      className={className}
      width={(height * 62) / 106}
      height={height}
      viewBox="0 0 62 106"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M62 31.441L0 0C0 5.78297 3.2603 11.0719 8.42676 13.67L43.7647 31.441L8.90249 46.4683C3.4997 48.7971 0 54.1166 0 60L62 31.441Z" />
      <path d="M-4.2832e-06 74.5589L62 106C62 100.217 58.7397 94.9281 53.5732 92.33L18.2353 74.5589L53.0975 59.5317C58.5003 57.2029 62 51.8833 62 46L-4.2832e-06 74.5589Z" />
      <path d="M62 34L8.82089 58.2766C3.44744 60.7297 0 66.0931 0 72L53.4313 47.3824C58.6543 44.976 62 39.7507 62 34Z" />
    </svg>
  );
}
